/*
//-------------------------------------------------------
//   Copyright (c) 2025 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     RequestWorkingTimes.js
//   Details:    RequestWorkingTimes.js
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI4743 25/02/25 JC       New
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import { Col, Row } from "react-bootstrap";
import moment from 'moment';
import { utils } from '../utils/utils';

class RequestWorkingTimes extends Component {

	render() {
		const { showWorkingTimes, workingTimes, hasWorkingTimes, workingTimeLength } = this.props;

		return (
			/* only show if there's working times and we want to show */
				hasWorkingTimes && showWorkingTimes ?
				<div>
					{workingTimes.map((workingTime, j) =>
						/* add a working time row for each item in the array, making sure we put a line after the last item */
						<Row key={`rwt-row-${j}`} className={`${j === (workingTimeLength -1) ? "button-tray top" : ""}`}>
							< Col sm = { 3} >
								<label>{workingTime.site}</label>
							</Col >
							<Col sm={9}>
								<label>{`${moment.utc(workingTime.startTime).format(utils.getDateTimeFormat())} - ${moment.utc(workingTime.endTime).format(utils.getDateTimeFormat())}`}</label>
								</Col>
						</Row>
					)}						
				</div >
				: [] )
	}
	}
;

export default RequestWorkingTimes;